import { deleteDoc, doc } from "firebase/firestore";
import { firebaseDB } from "../../firebase";

export const useDeleteTransaction = () => {
  const deleteTransaction = async (transactionId: string) => {
    const transactionDoc = doc(firebaseDB, "transactions", transactionId);
    await deleteDoc(transactionDoc);
  };
  return { deleteTransaction };
};
